import React, { useEffect, useCallback } from 'react';
import { Route } from 'react-router-dom';
import { useAuth0 } from 'utils/auth0';

const PrivateRoute = ({ component: Component, render: Render, path, ...rest }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth0();

  // Do login
  useEffect(() => {
    if (loading || isAuthenticated) {
      return;
    }

    const fn = async () => {
      await loginWithRedirect({
        appState: { targetUrl: path },
      });
    };

    fn();
  }, [loading, isAuthenticated, loginWithRedirect, path]);

  //

  const render = useCallback(
    props => {
      const returnComponent = Render ? <Render isPrivate {...props} /> : <Component isPrivate {...props} />;
      return isAuthenticated ? returnComponent : null;
    },
    [isAuthenticated, Render]
  );

  return <Route path={path} render={render} {...rest} />;
};

PrivateRoute.defaultProps = {
  component: null,
  render: () => {},
};

export default PrivateRoute;
